// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--81fdc";
export var divider = "Footer-module--divider--f364b";
export var link = "Footer-module--link--950f9";